import React from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import * as ETVConstants from '../ETVConstants';
import { Help } from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import ETVPage from '../tools/ETVPage';
import ETVActionButton from '../tools/ETVActionButton';
import ETVMessagePopup from '../tools/ETVMessagePopup';

class Support extends React.Component {

    state = {
      	isLoaded: false,
		sending:false,
		title:'',
		message:'',
		parent_email:'',
		parent_company: '',
		parent_addr1: '',
		parent_addr2: '',
		parent_zip: '',
		parent_city: '',
		parent_country: '',
		parent_phone: '',
		parent_url: '',
		info_message_title:'',
		info_message:'',
		info_type:'success',
		window:'',
		error:''
    }

    componentDidMount() {
		this.loadData();
    }

	loadData() {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/useradmin?action=get_parent&user_id="+this.props.user_id;
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
      	.then((response) => response.json())
      	.then((user) => {
        this.setState({
            parent_email: user.user_name,
			parent_company: user.company,
			parent_addr1: user.address_1,
			parent_addr2: user.address_2,
			parent_zip: user.zip,
			parent_city: user.city,
			parent_country: user.country,
			parent_phone: user.phone,
			parent_url: user.url,
			isLoaded:true,
         })
      })
      .catch((error) => {
      });
    }

	showWindow(divID, show) {
		show?this.setState({window:divID}):this.setState({window:''});
	}

	showInfoMessage(title,text,type='success') {
		this.setState({info_message_title:title,info_message:text,info_type:type});
		this.showWindow('message_div',true);
	}

	closeInfoMessage() {
		this.setState({info_message:'',info_message_title:''});
		this.showWindow('message_div',false);
	}

	sendCMDToServer(url) {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then((response) => response.json())
		.then((responseJson) => {
			if(responseJson['result']) {
				this.showInfoMessage(ETVConstants.trans("support_request"), ETVConstants.trans("support_request_sent"));
				this.setState({title:'',message:'',sending:false});
			}else{
				this.setState({sending:false});
				this.showInfoMessage('Unable to send',responseJson['error'] || responseJson['reason'] || 'Unable to send support request.','failure');
			}
		})
		.catch((error) => {
			console.error(error);
			this.setState({sending:false});
			this.showInfoMessage('Unable to send','Unable to send support request. Please try again.','failure');
		});
	}

	sendSupport() {
		this.setState({sending:true,error:''});
		var url = ETVConstants.getServerBase()+"/useradmin?action=get_support&user_id="+this.props.user_id+"&subject="+encodeURIComponent(this.state.title)+"&message="+encodeURIComponent(this.state.message);
		this.sendCMDToServer(url);
	}

    render() {

		var showButton = this.state.message && this.state.title;
      	return(
			<div style={{display:'block', width:'100%'}}>
				<ETVPage width="standard" icon={<Help fontSize="large"/>} title={ETVConstants.trans("support")} description={ETVConstants.trans("support_request")} loading={!this.state.isLoaded || this.state.sending}
					bottomActions={<ETVActionButton action="send" disabled={!showButton} loading={this.state.sending} onClick={() => this.sendSupport()}/>}>
						{this.state.isLoaded && <>
							<Typography variant='h5' style={{fontWeight:700}}>{ETVConstants.trans("support_contact")}</Typography>
							<div style={{marginTop:20}}/>
							<Typography variant='body1' style={{fontWeight:'bold'}}>{this.state.parent_company}</Typography>
							<Typography variant='body2'>
									{this.state.parent_addr1}<br/>
									{this.state.parent_addr2 && this.state.parent_addr2.length>0?<span>{this.state.parent_addr2}<br/></span>:<span/>}
									{this.state.parent_zip}<br/>
									{this.state.parent_city}<br/>
									{this.state.parent_country}<br/>
									{this.state.parent_phone}<br/>
									{this.state.parent_url}<br/>
									{this.state.parent_email}<br/>
									<br/>
									<br/>
							</Typography>
							<Typography variant='h6' style={{fontWeight:700}}>{ETVConstants.trans("support_request")}</Typography>
							{this.state.error?<Alert severity='error' style={{marginTop:16}}>{this.state.error}</Alert>:null}
							<TextField required style={{marginTop:20}} key='title' label={ETVConstants.trans("subject")} fullWidth={true} value={this.state.title} onChange={(event)=>{this.setState({title:event.target.value,error:''})}} />
							<br/>
							<br/>
							<TextField required multiline key='message_body' variant='outlined' label={ETVConstants.trans("message")} fullWidth={true} maxRows={10} minRows={7} value={this.state.message} onChange={(event)=>{this.setState({message:event.target.value,error:''})}} />
						</>}
				</ETVPage>

				<ETVMessagePopup open={this.state.window==='message_div'} onClose={()=>this.closeInfoMessage()}
					type={this.state.info_type} title={this.state.info_message_title} message={this.state.info_message}/>
	   	</div>);
	}
}

export default Support
